<!--通知第三方缴费&#45;&#45;第三方停车场-->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>

  import structure from "@/components/commonStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN6111",
          "parkName": "测试停车场",
          "parkingCode": "19000029902389",
          "carNo": "粤E12345",
          "enterTime": "20191017010101",
          "parkingFee": 2.01,
          "shouldPayValue": 1.99,
          "prePayKey": "12"
        },
        responseCode: {
          "data": {
            "thirdBillCode": "thirdbill0001",
            "payOrigin": "3",
            "payOriginRemark": "微信",
            "paymentMode": "12",
            "paymentModeRemark": "第三方余额"
          },
          "resultCode": 0,
          "message": "业务成功",
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统主动推送预存款扣费信息到开放平台",
          sdkcondition: "cmd=setPrestoreForThi",
          t_url: this.commonUrls.test+"reducePrestoreForThi",
          p_url: this.commonUrls.prod+"reducePrestoreForThi",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "开放平台提供接口, 第三方接入系统主动请求",
          frequency:"实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称'},
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号'},
              {info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号'},
              {info1: 'enterTime', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss进场时间'},
              {info1: 'parkingFee', info2: '是', info3: 'Decimal', info4: '流水此次停车总费用，单位：元'},
              {info1: 'shouldPayValue', info2: '是', info3: 'Decimal', info4: '需缴费用，单位：元'},
              { info1: 'prePayKey', info2: '否', info3: 'int', info4: '先扣费后离场标识，对应setPrestoreForThi下发预存款时的prePayKey' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'},
              {tableHead: '类型', tdName: 'info3'}, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方系统订单号，每条账单唯一，用于重复同步时判断重复和对账（不超过30位）'},
              {info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源'},
              {info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注(字段长度不得超过20位)'},
              {info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式'},
              {info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注(字段长度不得超过20位)'}
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/reducePrestoreForThi.vue